import { render, staticRenderFns } from "./CorpusAnnotationList.vue?vue&type=template&id=5b023574&scoped=true&"
import script from "./CorpusAnnotationList.vue?vue&type=script&lang=ts&"
export * from "./CorpusAnnotationList.vue?vue&type=script&lang=ts&"
import style0 from "./CorpusAnnotationList.vue?vue&type=style&index=0&id=5b023574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b023574",
  null
  
)

export default component.exports